type ValidateFormReturn = {
  valid: boolean;
  message: string;
};

export const validLength = (expression?: string, length = 8) => (expression?.length || 0) >= length;
export const hasNumber = (expression?: string) => /\d/.test(expression || "");
export const hasSpecialCharacter = (s?: string) =>
  /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(s || "");
export const hasUpperAndLowerCase = (s?: string) => /[a-z]/.test(s || "") && /[A-Z]/.test(s || "");
export function passwordMatch(password?: string, confirmPassowrd?: string) {
  return Boolean(password) && password === confirmPassowrd;
}

export function checkPasswordValidaty(password?: string, confirmPassowrd?: string) {
  return (
    validLength(password) &&
    hasNumber(password) &&
    // hasSpecialCharacter(password) &&
    hasUpperAndLowerCase(password) &&
    passwordMatch(password, confirmPassowrd)
  );
}

export default ValidateFormReturn;
